export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL; //'http://localhost:8080/';

export const ROLE = {
  sysadmin: "ROLE_SYSADMIN",
  admin: "ROLE_ADMIN",
  editor: "ROLE_EDITOR",
  viewer: "ROLE_VIEWER",
};
export const ROLE_CHOICES = [
  // {text:'Sys Admin',value: 'ROLE_SYSADMIN' },
  { text: "Admin", value: "ROLE_ADMIN" },
  { text: "User", value: "ROLE_EDITOR" },
  // {text:'Viewer',value: 'ROLE_VIEWER' },
];

export const YESNO_CHOICES = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];

export const AUTH_PROVIDER = {
  facebook: "facebook",
  twitter: "twitter",
  google: "google",
  local: "local",
};
export const NAME_TITLE_TH = [
  { text: "นาย", value: "นาย" },
  { text: "นาง", value: "นาง" },
  { text: "นางสาว", value: "นางสาว" },
  // {text:'อื่นๆ(ระบุ)',value: 'อื่นๆ(ระบุ)' },
];

export const SIDEBAR_SCREEN = {
  width: {
    mobile: 80,
    pc: 450,
  },
};

export const SERVER_SYNC_INTERVAL = 15000;
export const DEFAULT_LANG = "th";
